import { lookupGetStateOld } from 'legacy/lut/store'
import React, { useEffect, useState } from 'react'

import { Button } from 'core-components/library/button'
import { Input } from 'core-components/library/inputs'
import { IDataProviderFilter, IFilter, Logic, Operator } from 'core-components/types'
import { ICountry } from 'core/classes/models/IReference'
import { Crud } from 'core/types/Crud'

import styles from './CustomFilterContactData.module.scss'

export interface ICustomFilterProps {
  currentValue: string | IFilter | IDataProviderFilter
  onChange: (value: string | IFilter | IDataProviderFilter) => void
  source: Crud
  field: string
  currentOperation: string
  onBlur: () => void
}

export const CustomFilterContactData = (props: ICustomFilterProps) => {
  const [filterValue, setFilterValue] = useState('')
  useEffect(() => {
    const countries = lookupGetStateOld().references.countries
    if ((props.currentValue as IDataProviderFilter).filters) {
      if ((props.currentValue as IDataProviderFilter).filters.length === 1) {
        const countriesName = countries.find(
          (country) =>
            country.value ===
            ((props.currentValue as IDataProviderFilter).filters[0] as IFilter).value
        )
        setFilterValue(countriesName ? countriesName.name : '')
      } else {
        setFilterValue('')
      }
    } else {
      const countriesName = countries.find((country) => country.value === props.currentValue)
      setFilterValue(countriesName ? countriesName.name : '')
    }
  }, [props.currentValue])
  const getFilter = (value: string, operator: Operator) => {
    const countries = lookupGetStateOld().references.countries
    const code =
      operator === Operator.CONTAINS
        ? countries.filter((el) => el.name.includes(value))
        : countries.find((el) => el.name === value)
    if (operator === Operator.CONTAINS) {
      const filter = (code as ICountry[]).map((i) => ({
        operator,
        value: i.value,
        field: 'CountryOfBusiness',
      }))
      return filter.length
        ? {
            logic: Logic.OR,
            filters: filter,
          }
        : {
            operator,
            value: filterValue,
            field: 'CountryOfBusiness',
          }
    }
    return {
      operator,
      value: code ? code['value'] : value,
      field: 'CountryOfBusiness',
    }
  }
  const apply = () => {
    const all = (props.source as Crud).getFilter()
    if (all) {
      const newFilters = all.filters.filter((f) => (f as IFilter).field !== props.field)
      const filters = getFilter(filterValue, props.currentOperation as Operator)
      if (filters) {
        newFilters.push(filters)
      }
      props.source.setFilter({ ...all, filters: newFilters })
      return
    }
    props.source.setFilter({
      logic: Logic.AND,
      filters: [
        {
          field: props.field,
          operator: props.currentOperation as Operator,
          value: filterValue,
        },
      ],
    })
  }
  const clear = () => {
    const all = props.source.getFilter()
    if (all) {
      const found = all.filters.findIndex((f) => (f as IFilter).field === props.field)
      const findedFilters = all.filters.findIndex(
        (f) =>
          (f as IDataProviderFilter).filters &&
          (f as IDataProviderFilter).filters.length &&
          (f as IDataProviderFilter).filters.find(
            (filter) => (filter as IFilter).field === props.field
          )
      )
      if (found > -1 || findedFilters > -1) {
        const newFilters = [...all.filters]
        newFilters.splice(found, 1)
        props.source.setFilter({ ...all, filters: newFilters })
        return
      }
    }
    props.onChange('')
    props.onBlur()
  }
  return (
    <div
      onKeyDown={(e: any) => {
        if (e.key === 'Enter') {
          apply()
        } else if (e.key === 'Escape') {
          clear()
        }
      }}
    >
      <Input
        value={filterValue}
        onChange={(value) => {
          setFilterValue(value)
        }}
        margin={'sm'}
        label={'Country Of Business'}
      />
      <div className={styles.footer}>
        <Button className={styles.footer__item} onClick={apply}>
          Apply
        </Button>
        <Button className={styles.footer__item} color={'danger'} onClick={clear}>
          Clear
        </Button>
      </div>
    </div>
  )
}
